import React, { useState, useEffect } from 'react';
import { fetchRejectionReasons as fetchRejectionReasonsApi, getRejectionSubcategories } from '../config/api';

const RejectionReasonSelector = ({ onReasonSelect, selectedReason }) => {
  const [reasons, setReasons] = useState([]);
  const [groupedReasons, setGroupedReasons] = useState({});
  const [groupedBySubcategory, setGroupedBySubcategory] = useState({});
  const [subcategoriesByCategory, setSubcategoriesByCategory] = useState({});
  const [allSubcategories, setAllSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('category'); // 'category' or 'subcategory'

  useEffect(() => {
    fetchRejectionReasons();
  }, []);

  // Fetch all rejection reasons with subcategory grouping.
  // Uses the shared API client so the configured REACT_APP_API_URL is honored
  // (a relative fetch() would hit the frontend origin in production).
  const fetchRejectionReasons = async () => {
    try {
      const data = await fetchRejectionReasonsApi();
      if (data) {
        setReasons(data.rejectionReasons);
        setGroupedReasons(data.groupedReasons);
        setGroupedBySubcategory(data.groupedBySubcategory);
        setSubcategoriesByCategory(data.subcategoriesByCategory);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching rejection reasons:', error);
      setLoading(false);
    }
  };

  // Fetch just the subcategories (lighter response)
  const fetchSubcategories = async () => {
    try {
      const data = await getRejectionSubcategories();
      
      // Access subcategory data
      console.log('Subcategories by category:', data.data.subcategoriesByCategory);
      console.log('All subcategories:', data.data.allSubcategories);
      
      if (data.success && data.data) {
        setSubcategoriesByCategory(data.data.subcategoriesByCategory);
        setAllSubcategories(data.data.allSubcategories);
      }
      
      return data.data;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    }
  };

  if (loading) return <div>Loading rejection reasons...</div>;

  return (
    <div className="rejection-reason-selector">
      <label htmlFor="rejection-reason">Select Rejection Reason:</label>
      <select 
        id="rejection-reason"
        value={selectedReason || ''} 
        onChange={(e) => onReasonSelect(e.target.value)}
        className="rejection-select"
      >
        <option value="">Choose a reason...</option>
        {Object.entries(groupedReasons).map(([category, categoryReasons]) => (
          <optgroup key={category} label={category}>
            {categoryReasons.map(reason => (
              <option key={reason.id} value={reason.id}>
                {reason.title} - {reason.description}
                {reason.subcategory && ` (${reason.subcategory})`}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      
      {/* Debug information */}
      <div className="mt-4 p-3 bg-gray-100 rounded text-xs">
        <h4 className="font-semibold mb-2">Debug Info:</h4>
        <div className="space-y-1">
          <div>Total reasons: {reasons.length}</div>
          <div>Categories: {Object.keys(groupedReasons).length}</div>
          <div>Subcategories: {Object.keys(groupedBySubcategory).length}</div>
          <div>Categories with subcategories: {Object.keys(subcategoriesByCategory).length}</div>
          <div>All subcategories: {allSubcategories.length}</div>
        </div>
        
        <div className="mt-3 space-x-2">
          <button
            onClick={fetchSubcategories}
            className="px-2 py-1 bg-blue-500 text-white rounded text-xs hover:bg-blue-600"
            title="Fetch subcategories only"
          >
            Fetch Subcategories Only
          </button>
          <button
            onClick={fetchRejectionReasons}
            className="px-2 py-1 bg-green-500 text-white rounded text-xs hover:bg-green-600"
            title="Fetch all reasons"
          >
            Fetch All Reasons
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionReasonSelector;
